import { struct } from 'io-ts/Decoder';

import { FormId as StepFormId } from '../../../../../job/create/step/Id';
import { Id as JobId } from '../../../../../job/Id';

export const ParamWithoutJob = struct({
	stepId: StepFormId,
});

export const ParamWithJob = struct({
	jobId: JobId,
	stepId: StepFormId,
});
